import { create } from 'zustand';

const useBusinessStore = create((set, get) => ({
  // Stores the list of businesses. Initially as an empty array
  businesses: [],

  //:: Function to update the business list.
  setBusinesses: (businesses) => {
    if (Array.isArray(businesses)) {
      set({ businesses });
    } else if (typeof businesses === 'function') {
      const currentBusinesses = get().businesses;
      const result = businesses(currentBusinesses);
      set({ businesses: result });
    } else {
      set({ businesses: [] });
    }
  },

  // State that stores the business currently selected by the user
  selectedBusiness: null,

  //:: Function to select a business. Updates the status with the ID of the selected business.
  setSelectedBusiness: (businessId) => {
    set({ selectedBusiness: businessId });
    const { businesses } = get();
    const business = Array.isArray(businesses)
      ? businesses.find((b) => b.id === businessId)
      : null;
    if (business?.role) {
      localStorage.setItem('user_role', business.role);
    }
  },

  //:: Function that obtains the selected business from the current state.
  getSelectedBusiness: () => {
    const { businesses, selectedBusiness } = get();
    return Array.isArray(businesses)
      ? businesses.find((business) => business.id === selectedBusiness)
      : null;
  },

  //:: Function that obtains the selected business details, including ID and name
  getSelectedBusinessDetails: () => {
    const selectedBusiness = get().getSelectedBusiness();

    return {
      businessId: selectedBusiness?.id,
      selectedBusinessName: selectedBusiness?.name,
      selectedBusinessLogo: selectedBusiness?.logo_url,
      selectedBusinessUrl: selectedBusiness?.api_url,
    };
  },

  //:: Get the role of the selected business for easier access across components
  getUserRole: () => {
    const selectedBusiness = get().getSelectedBusiness();
    return selectedBusiness?.role || localStorage.getItem('user_role') || null;
  },

  // Active modules for the selected business (null = all modules enabled)
  activeModules: null,

  setActiveModules: (modules) => set({ activeModules: modules }),

  isModuleActive: (moduleKey) => {
    const { activeModules } = get();
    return Array.isArray(activeModules) && activeModules.includes(moduleKey);
  },

  // Handle whether the channel is connected or not
  isChannelConnected: false,

  //:: Function to update the channel connection status
  setIsChannelConnected: (connected) => set({ isChannelConnected: connected }),

  // Handle whether redirect is allowed
  allowRedirect: false,

  //:: Function to update the redirect permission
  setAllowRedirect: (allow) => set({ allowRedirect: allow }),

  //! ---- NEW STATE & FUNCTIONS FOR last_contact (CustomerDetails.jsx) ----

  lastContactUpdates: {},

  //:: Function to update last_contact by customer_id
  updateLastContact: (customerId, lastContact) =>
    set((state) => ({
      lastContactUpdates: {
        ...state.lastContactUpdates,
        [customerId]: lastContact,
      },
    })),

  //:: Function to get all updates from last_contact
  getLastContactUpdates: () => get().lastContactUpdates,

  //! ---- NEW STATE & FUNCTIONS FOR sentiment score (CustomerDetails.jsx) ----
  sentimentUpdates: {},

  updateSentimentScore: (customerId, sentimentScore) =>
    set((state) => ({
      sentimentUpdates: {
        ...state.sentimentUpdates,
        [customerId]: sentimentScore,
      },
    })),

  getSentimentUpdates: () => get().sentimentUpdates,

  // Store business notifications
  businessNotifications: [],

  setBusinessNotifications: (notifications) =>
    set({ businessNotifications: notifications }),

  updateBusinessNotifications: (notifications) =>
    set((state) => ({
      businessNotifications: [...state.businessNotifications, notifications],
    })),

  getBusinessNotifications: () => get().businessNotifications,
}));

export default useBusinessStore;
